import React from 'react';

const GoogleCloudLogo = props => (
  <svg width={32} height={26} {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M0-3h32v32H0z" />
      <path
        d="M20.218 7.136h.97l2.764-2.745.135-1.165A12.487 12.487 0 0 0 12.3.659a12.376 12.376 0 0 0-8.42 8.585c.308-.125.649-.145.97-.057l5.527-.906s.281-.462.426-.433a6.93 6.93 0 0 1 9.436-.712h-.02z"
        fill="#EA4335"
        fillRule="nonzero"
      />
      <path
        d="M27.888 9.244a12.352 12.352 0 0 0-3.752-6.008l-3.879 3.851a6.827 6.827 0 0 1 2.53 5.432v.683c1.907 0 3.453 1.535 3.453 3.428 0 1.894-1.546 3.429-3.452 3.429h-6.904l-.689.693v4.112l.689.683h6.904c3.959.031 7.47-2.516 8.645-6.27a8.885 8.885 0 0 0-3.545-10.033z"
        fill="#4285F4"
        fillRule="nonzero"
      />
      <path
        d="M8.97 25.509h6.904V20.02H8.97c-.492 0-.978-.105-1.426-.308l-.97.298-2.782 2.745-.243.963a8.972 8.972 0 0 0 5.42 1.79z"
        fill="#34A853"
        fillRule="nonzero"
      />
      <path
        d="M8.97 7.704c-3.835.022-7.233 2.461-8.457 6.07A8.88 8.88 0 0 0 3.55 23.69l4.005-3.977a3.424 3.424 0 0 1-1.996-3.608 3.44 3.44 0 0 1 2.93-2.91 3.458 3.458 0 0 1 3.633 1.982l4.005-3.977A8.992 8.992 0 0 0 8.97 7.704z"
        fill="#FBBC05"
        fillRule="nonzero"
      />
      <path d="M0-3h32v32H0z" />
    </g>
  </svg>
);

export default GoogleCloudLogo;



// WEBPACK FOOTER //
// ./src/javascripts/app/Webhooks/templates/logos/GoogleCloudLogo.es6.js